import { Outlet } from "react-router";
import Header from "../../component/layout/header";
import useNav from "../../script/tabingNavArray";

const LogsLayout = () => {
  const navList = useNav();
  let { logsBottomNav, topLogNav } = navList;
  return (
    <div className="webBody">
      <Header bottomTabs={logsBottomNav} topTabs={topLogNav} />
      <Outlet />
    </div>
  );
};

export default LogsLayout;
